
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adjust",
      function () {
        return require("private-next-pages/destinations/adjust.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adjust"])
      });
    }
  